<template>
    <div id="NotificationPopup" style="max-width: 500px !important; min-height: auto">
        <q-card style="max-width: 500px !important; min-height: auto" v-if="notification">
            <div class="row q-pa-md">
                <div class="d-flex col-12 q-pa-md pt-0 pr-0"
                     style="justify-content: space-between; align-items: center ">
                    <div>
                        <h4 style="font-size: 22px; font-weight: 300;">
                            Notification Details
                        </h4>
                    </div>
                    <div class="drawerButtons" style="margin-top: -10px;">
                        <q-btn @click="closePopup" dense flat icon="close" round/>
                    </div>
                </div>
                <div class="col-12 q-pa-md">
                    <div class="notification-img">
                        <img :src="notification.notification.image?notification.notification.image:getNotificationImage(notification.data.notificationType)">
                    </div>
                </div>

                <div class="col-12 q-pa-md mt-3">
                    <div class="noti-content">
                        <h5>{{notification.notification.title}}</h5>
                        <p class="mt-1">{{notification.notification.body}}</p>
                        <p class="mb-0">{{timeFromFilter(notification.data.notificationTime)}}</p>
                    </div>
                </div>
            </div>
        </q-card>
    </div>
</template>

<script>
  export default {
    name: 'NotificationPopup',
    data () {
      return {
        defaultNotificationImage: require('../../assets/icons/notification.png'),
        defaultOrderImage: require('../../assets/icons/order.png'),
        defaultSchemeImage: require('../../assets/icons/scheme.png'),
        notification: JSON.parse(localStorage.currentNotification),
      }
    },
    methods: {
      getNotificationImage (notificationType) {
        if (notificationType == 11)
          return this.defaultOrderImage
        else if (notificationType == 22)
          return this.defaultSchemeImage
        else
          return this.defaultNotificationImage
      },
      closePopup () {
        localStorage.removeItem('currentNotification')
        this.$emit('closeDialog')
        this.$forceUpdate()
      },
    },
  }
</script>

<style lang="scss" scoped>
    .notification-img {
        height: 250px;
        width: auto;
        background: #f5f5f5;
        border-radius: 5px;
        overflow: hidden;

        img {
            max-width: 100%;
            margin-left: auto;
            margin-right: auto;
            display: block;
            height: auto;
        }
    }

    .noti-content {
        h5 {
            font-weight: bolder;
            color: #313131;
        }

        p {
            color: #7b7b7b;
            font-size: 14px;
        }
    }

</style>
